import React from 'react';
import AdvertisementContainer from 'containers/AdvertisementContainer';

export default function AdvertisementPage() {
  return <AdvertisementContainer />;
}
